/**
 * Validated frontend env. Throws at module load if a required var is missing,
 * so we fail loudly during dev rather than producing a broken portal.
 */

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
}

export const env = {
  clerkPublishableKey: required(
    'VITE_CLERK_PUBLISHABLE_KEY',
    import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  ),
  outreachApiUrl: required('VITE_OUTREACH_API_URL', import.meta.env.VITE_OUTREACH_API_URL),
  // Optional: when set, /admin/discovery is enabled and mounts the
  // spade-discovery UI pointing at this URL. Leave unset to hide the tab.
  discoveryApiUrl: import.meta.env.VITE_DISCOVERY_API_URL ?? '',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY ?? '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST ?? '',
} as const;
